<div class="space backgrounds"></div>
<div class="slider sliders">
 <div class="box sliders">
     <div class="wrapper">
         <div class="info">
                 <h1 class="titlestyle">{{ 'cloud.title860' | translate }}</h1>
         </div>
     </div>
 </div>
</div>
<main class="backgrounds">
 <div class="container">
   <div class="row">
     <div class="col-lg-8 col-xs-12 firstone">
       <section class="articles sectionboard">
        <div *ngIf="datas.length>0">
          <article class="hideshadow"
          *ngFor="
            let data of datas
              | paginate
                : {
                    itemsPerPage: 5,
                    currentPage: page,
                    totalItems: totalLength
                  }
            index as i
          "
        >
          <div class="articles-header">
            <time>{{ data.date | date: "dd/MM/yyyy" }}</time>
            <span class="articles-header-category">
              <a class="blue">{{ data._embedded['wp:term']['0']['0'].name }}</a>
            </span>
          </div>
          <div class="articles-content">
            <div>
              <img src="{{ data._embedded['wp:featuredmedia']['0'].source_url }}" class="imgsize" alt="foto" width="100%" />
            </div>
            <h1>
              <a title="">{{ data.title.rendered }}</a>
            </h1>
            <p [innerHTML]="data.excerpt.rendered">
              {{ data.excerpt.rendered | filter: 90 }}
            </p>
          </div>
          <div class="paddings">
            <a [routerLink]="['/pagina', data.id, data.slug]" class="butttomstyle"
              >{{ 'cloud.title862' | translate }}</a
            >
          </div>
          <hr class="solid">
        </article>
        </div>
        <div *ngIf="datas.length==0">
          {{ 'cloud.title863' | translate }}
        </div>
       </section>
       <pagination-controls previousLabel="" nextLabel=""
       (pageChange)="page = $event; onPageChange($event)"
     ></pagination-controls>
     </div>
     <div  class="aside-blocks col-lg-4 col-xs-12 secondone">
      <div class="dropdown">
        <button class="dropbtn">{{ 'cloud.title860' | translate }}</button>
        <div class="dropdown-content">
          <aside class="categories centered p-3 searchbar">
            <input class="form-control mr-sm-2" type="search" placeholder="{{ 'cloud.title860' | translate }}" aria-label="Search" id="searchelement">
            <button class="btn btn-outline-success my-2 my-sm-0 mt-1" type="submit" style="margin-top: 1rem !important;" (click)="testing(true)">{{ 'cloud.title860' | translate }}</button>
          </aside>
        </div>
      </div>
      <div class="dropdown">
        <button class="dropbtn">{{ 'cloud.title861' | translate }}</button>
        <div class="dropdown-content">
          <aside class="author">
            <div class="barra">
              <ul *ngFor="let data of novedades; index as i">
               <li class="nav-elipse-blue">
                 <a
                 [routerLink]="['/pagina', data.id, data.slug]"
                   title="{{ data.title.rendered }}"
                   >{{ data.title.rendered }}</a
                 >
               </li>
             </ul>
            </div>
          </aside>
        </div>
      </div>
      <div class="dropdown">
        <button class="dropbtn">{{ 'cloud.title859' | translate }}</button>
        <div class="dropdown-content">
          <aside class="categories">
            <h2 class="aside-title">{{ 'cloud.title859' | translate }}</h2>
            <ul *ngFor="let categorie of categories; index as i">
              <li class="nav-elipse-blue">
                <a (click)="searchCategory(categorie.id)"
                title="{{ categorie }}"
                >{{ categorie.name }}</a
              >
              </li>
            </ul>
          </aside>
        </div>
      </div>

             <aside class="categories centered p-3 searchbar shadows">
              <input class="form-control mr-sm-2" type="search" placeholder="{{ 'cloud.title860' | translate }}" aria-label="Search" id="searchelement2">
              <button class="btn btn-outline-success my-2 my-sm-0 mt-1" type="submit" style="margin-top: 1rem !important;" (click)="testing(false)">{{ 'cloud.title860' | translate }}</button>
             </aside>
             <aside class="author shadows">
               <div class="barra">
                 <h2>{{ 'cloud.title861' | translate }}</h2>
                 <ul *ngFor="let data of novedades; index as i">
                  <li class="nav-elipse-blue">
                    <a
                    [routerLink]="['/pagina', data.id, data.slug]"
                      title="{{ data.title.rendered }}"
                      >{{ data.title.rendered }}</a
                    >
                  </li>
                </ul>
               </div>
             </aside>
             <aside class="categories shadows">
               <h2 class="aside-title">{{ 'cloud.title859' | translate }}</h2>
               <ul *ngFor="let categorie of categories; index as i">
                <li class="nav-elipse-blue">
                  <a (click)="searchCategory(categorie.id)"
                  title="{{ categorie }}"
                  >{{ categorie.name }}</a
                >
                </li>
               </ul>
             </aside>
           </div>
   </div>
 </div>
</main>
<main>
   <div>
       <div>

       </div>
   </div>
</main>

<iframe width="100%" height="300" [src]="url" style="display: none;"></iframe>
